import { combineReducers } from 'redux';
import app from './app';
import loading from './loading';
import groupFilter, { groupFilterRelations } from './grouping';
import queryParams from './queryParams';
import site from './site';
import loggers from './loggers';
import sensors from './sensors';
import chartOptions from './chartOptions';
import sankeyColumnFilter from './sankeyColumnFilter';
import sankeyOptions from './sankeyOptions';

const rootReducer = combineReducers({
  app,
  loading,
  groupFilter,
  groupFilterRelations,
  queryParams,
  site,
  loggers,
  sensors,
  chartOptions,
  sankeyColumnFilter,
  sankeyOptions
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js